export const styledCellSX = {
    borderBottom: "none",
};

export const styledRowSX = {
    ...styledCellSX,
    width: "100%",
    height: "46px",
};
